import { translateFunc } from "client/utils/translateFunc";
import { Checkbox } from "components/common/Checkbox/Checkbox";
import { ColorInput } from "components/common/ColorInput/ColorInput";
import { QuestionIcon } from "components/common/Icons/QuestionIcon";
import { Radio } from "components/common/Radio/Radio";
import { ToolTip } from "components/common/ToolTip/ToolTip";
import { useFillColor } from "./useFillColor";

export const FillColor = () => {
    const { color, handleColorChange, handleShouldFillColorChange, shouldFillColor, handleFillColorTypeChange, type } =
        useFillColor();

    return (
        <div className="flex flex-col dark:bg-darkSurface-200 gap-4 py-4 px-6 rounded-lg border-irGray-400 dark:border-darkSurface-400 border">
            <div className="flex items-center">
                <Checkbox
                    defaultIsChecked={shouldFillColor}
                    handleChange={handleShouldFillColorChange}
                    label={translateFunc("background-fill")}
                    testId="fill-color"
                />
                <div className="ml-auto">
                    <ToolTip text={translateFunc("fill-color-tooltip-text")}>
                        <QuestionIcon />
                    </ToolTip>
                </div>
            </div>

            {shouldFillColor && (
                <>
                    <div className="border-b-irGray-400 border-b w-full" />

                    <div className="flex flex-col gap-4">
                        <div className="flex items-center" data-testid={`color-input-container`}>
                            <Radio
                                value={type === "color"}
                                handleClick={() => handleFillColorTypeChange("color")}
                                label={translateFunc("pick-a-color")}
                            />
                            <div className="ml-auto flex items-center gap-4">
                                <ColorInput defaultColor={color} handleChange={handleColorChange} />
                            </div>
                        </div>
                        <div>
                            <Radio
                                value={type === "transparent"}
                                label={translateFunc("transparent")}
                                handleClick={() => handleFillColorTypeChange("transparent")}
                            />
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};
